export default "__VITE_ASSET__BFQ29xBN__"